import React from "react";
import { Navbar, Nav, Container, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import logo_cmdic from "../img/collahuasi-logo-1.png";
import logo_gaudi from "../img/logo-gaudi-01.png";

const Header = () => {
    // Mostrar el link "Cambiar proceso" para admin institución (Retorno 2) o
    // superusuario (Retorno 3), para volver al selector sin re-loguear.
    const ticket = useSelector((state) => state.ticket);
    const isAdmin = ticket && (ticket.Retorno == 2 || ticket.Retorno == 3);

    return (
        <Navbar bg="light" variant="light" expand="lg">
            <Container>
                <Navbar.Brand>
                    <img
                        alt=""
                        src={logo_cmdic}
                        width="200                        "
                        // height="27"
                        className="d-inline-block align-top  xz-logo-1"
                    />
                    <span className="fw-bold"></span>
                </Navbar.Brand>
                {isAdmin && (
                    <Nav className="ms-auto me-3">
                        <Nav.Link
                            as={Link}
                            to="/seleccionar-proceso"
                            className="text-secondary"
                        >
                            Cambiar proceso
                        </Nav.Link>
                    </Nav>
                )}
                <Navbar.Brand>
                    <img
                        alt=""
                        src={logo_gaudi}
                        width="140"
                        // height="27"
                        className="d-inline-block align-top xz-logo-2"
                    />
                    <span className="fw-bold"></span>
                </Navbar.Brand>
            </Container>
        </Navbar>
    );
};

export default Header;
